import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormGroup, Radio, ControlLabel, OverlayTrigger } from 'react-bootstrap';
import AdditionalInfoComponentC from './AdditionalInfoComponent';

export class RadioContainer extends React.Component {
    constructor(props) {
        super(props);

        this.onChangeHandler = this.onChangeHandler.bind(this);
        const name = this.props.data.name;

        this.state = {
            // value: this.props.initialValues[name] ? this.props.initialValues[name] : null,
            disabled:
                this.props.initialParams[name] && this.props.initialParams[name].disabled
                    ? this.props.initialParams[name].disabled
                    : false,
            options: [].concat(this.props.data.attributes.options),
            isValid: null,
            validationMessage: ''
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.hidden!=nextProps.hidden && nextProps.hidden && this.state.value!==null) {
            this.setState({
                value: null
            });
        }
    }

    componentWillMount() {
        if (this.props.initialValues[this.props.data.name]) {
            const event = {
                target: {
                    value: this.props.initialValues[this.props.data.name]
                }
            };
            this.onChangeHandler(event);
        } else {
            this.setState({
                value: null
            });
        }
    }

    getValidationState() {
        // this bit of code acts as a circuit breaker
        // We want get validation to trigger a validation function
        // and when results are back we need to call it again
        // But this breaks the loops
        if (this.state.isValid) {
            const isValid = this.state.isValid;
            this.state.isValid = null;
            return isValid;
        }

        // only trigger validation if the value changes
        if (
            this.state.value !== '' &&
            this.props.data.attributes &&
            this.props.data.attributes.validationFunc &&
            this.props.validation[this.props.data.attributes.validationFunc]
        ) {
            this.props.validation[this.props.data.attributes.validationFunc](
                this.props.data.name,
                this.state.value
            ).then(result => {
                this.setState({
                    isValid: result ? 'success' : 'error',
                    validationMessage: result.status ? '' : result.message
                });
            });
        }

        if (this.state.isValid !== null) {
            return this.state.isValid;
        }

        if (this.props.data.attributes && this.props.data.attributes.validationRegEx) {
            const regex = new RegExp(unescape(this.props.data.attributes.validationRegEx));
            return regex.test(this.state.value) ? 'success' : 'error';
        }

        return;
    }

    onChangeHandler(event) {
        // get the data for selected option
        const option = this.props.data.attributes.options.filter(optionResult => {
            return optionResult.value.toString() === event.target.value;
        })[0];

        // trigger supplemental questions
        if (option.supplementalquestionIds && option.supplementalquestionIds.length > 0) {
            this.props.handleSupplementTrigger(option.supplementalquestionIds);
        } else {
            this.props.handleSupplementTrigger([]);
        }
        if (this.props.data.name==="generalContractorKnown" && !this.props.isUnderwriter) {
            if (event.target.value) {
                    this.props.handleDisableFieldChange();
                }
            else {
                    this.props.handleDisableFieldChange('', '', this.props.data.disableOtherField);
                }
        }
        // set value to selected option
        this.setState({
            value: event.target.value
        });

        this.props.handleFormChange();
    }

    render() {

        const optionsItems = this.props.data.attributes.options || [];

        const options = optionsItems.map((data, index) => {
            const checked =
            this.props.hidden && this.props.initialValues[data.name] === undefined ? false : this.state.value && this.state.value.toString() === data.value.toString();

            return (
                <Radio
                    className={this.props.data.name}
                    key={index}
                    onChange={this.onChangeHandler}
                    value={data.value}
                    checked={checked}
                    inline={this.props.data.verticalRadioAlign}
                    disabled={this.state.disabled}
                    name={`optionGroup_${this.props.data.questionId}`}
                >
                    <span className="radioText">{data.text}</span>
                </Radio>
            );
        });

        return (
            <FormGroup
                className="radioGroup"
                validationState={this.getValidationState()}
                controlId={this.props.data.name}
            >
                <ControlLabel className={classNames({mandatoryField: this.props.data.required, requiredLabel: (!this.state.value && this.props.requiredLabel) })}>{this.props.data.text}</ControlLabel>
                {this.props.data.placeholder && (
                    <label className={classNames({
                        'required': this.props.data.required,
                        'placeholder-tooltip-hidden': this.props.data.placeholderHidden,
                        'placeholder-tooltip-exposed': this.props.data.placeholderExposed && !this.props.data.placeholderHidden,
                        'placeholder': !this.props.data.placeholderHidden && !this.props.data.placeholderExposed,
                        'red-placeholder': this.props.data.questionId==='997_supplemental2'
                    })}>
                        {this.props.data.placeholder}
                    </label>
                )}

                <div className="options">{options}</div>
                {
                    this.props.data.helper &&
                    <div className={classNames({
                    'helper-red': this.props.data.questionId==='32' || this.props.data.questionId==='5',
                    'helper': this.props.data
                    })}>{this.props.data.helper}
                    {this.props.data.helper2 &&
                    <div className={classNames({'helper-red': this.props.data.questionId==='32'})}>{this.props.data.helper2}</div>}
                    </div>
                }
                <AdditionalInfoComponentC
                    additionalInfo1Color={this.props.data.additionalInfo1Color}
                    additionalInfo1={this.props.data.additionalInfo1}
                    additionalInfo2={this.props.data.additionalInfo2}
                    additionalInfoIcon={this.props.data.additionalInfoIcon}
                />
            </FormGroup>
        );
    }
}

RadioContainer.propTypes = {
    data: PropTypes.object,
    initialParams: PropTypes.object,
    initialValues: PropTypes.object,
    validation: PropTypes.object,
    handleSupplementTrigger: PropTypes.func,
    handleFormChange: PropTypes.func
};

export default RadioContainer;
